"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dnd_1 = require("react-dnd");
var Sortable = function (_a) {
    var children = _a.children, index = _a.index, onMove = _a.onMove, onDrop = _a.onDrop;
    var ref = react_1.useRef(null);
    var _b = react_dnd_1.useDrop({
        accept: 'MEDIA',
        collect: function (monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            };
        },
        drop: function (item) {
            return { index: item.index };
        },
        hover: function (item, monitor) {
            if (!ref.current) {
                return;
            }
            var dragIndex = item.index;
            var hoverIndex = index;
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return;
            }
            // Time to actually perform the action
            onMove(dragIndex, hoverIndex);
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex;
        },
    }), handlerId = _b[0].handlerId, drop = _b[1];
    var _c = react_dnd_1.useDrag({
        type: 'MEDIA',
        item: function () {
            return { index: index };
        },
        collect: function (monitor) { return ({
            isDragging: monitor.isDragging(),
        }); },
        end: function (item) {
            // Don't replace items with themselves
            if (index === item.index) {
                return;
            }
            onDrop(index, item.index);
        },
    }), isDragging = _c[0].isDragging, drag = _c[1];
    drag(drop(ref));
    return (react_1.default.createElement("div", { ref: ref, "data-handler-id": handlerId, style: { cursor: isDragging ? 'grabbing' : 'grab' } }, children));
};
exports.default = Sortable;
